import React from "react";
import { LegalLayout, Section } from "../components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="June 2026" testid="terms-page">
      <Section heading="Acceptance of terms">
        By using NarcCheck AI you agree to these terms. If you do not agree, please do not use the
        service.
      </Section>

      <Section heading="What NarcCheck AI is — and isn't">
        NarcCheck AI uses artificial intelligence to estimate narcissistic and manipulative
        communication patterns in a conversation and generate a scorecard. It is provided for
        <b> personal reflection and entertainment only</b>. It is <b>not</b> a substitute for
        professional medical, psychological, legal, or relationship advice, and its output must not be
        used to diagnose, label, or make consequential decisions about any person. Scores are
        AI-generated opinions, not clinical facts.
      </Section>

      <Section heading="Your responsibilities">
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          <li>Only submit content you have the right to share.</li>
          <li>Do not use the service to harass, defame, or harm others.</li>
          <li>You are responsible for how you interpret and act on any analysis.</li>
          <li>You must be at least 18 years old (or the age of majority where you live).</li>
        </ul>
      </Section>

      <Section heading="Free usage & NarcCheck Pro">
        New users receive a limited number of free analyses. Beyond that, a NarcCheck Pro subscription
        is required for unlimited analyses. Pro is offered as a recurring subscription — Monthly
        ($8.99/month) or Annual ($60/year) — billed automatically until cancelled.
      </Section>

      <Section heading="Billing, renewal & cancellation">
        Subscriptions are processed by Stripe and renew automatically at the end of each billing period
        unless cancelled beforehand. You can cancel at any time; access continues until the end of the
        current paid period. Except where required by law, payments are non-refundable. Prices may
        change with notice for future billing periods.
      </Section>

      <Section heading="Accounts">
        You are responsible for activity under your account. You may delete your account at any time
        from Settings, which removes your saved history and ends your sessions.
      </Section>

      <Section heading="No warranty & limitation of liability">
        The service is provided "as is" without warranties of any kind. To the maximum extent permitted
        by law, we are not liable for any indirect, incidental, or consequential damages arising from
        your use of the service or reliance on its output.
      </Section>

      <Section heading="Changes to these terms">
        We may update these terms from time to time. Continued use of the service after changes take
        effect constitutes acceptance of the revised terms.
      </Section>

      <Section heading="Contact">
        Questions? Email{" "}
        <a className="link" href="mailto:Goldenknee@gmail.com">Goldenknee@gmail.com</a>.
      </Section>
    </LegalLayout>
  );
}
